<div class="mt-1 mb-3">
  <div class="flex flex align-items-center gap-5">
    <p-iconField iconPosition="left">
      <p-inputIcon styleClass="fas fa-search" />
      <input
        class="w-20rem"
        pInputText
        placeholder="durchsuchen ..."
        [(ngModel)]="filterQuery.query"
        (ngModelChange)="updateFilter()" />
    </p-iconField>
    <div class="flex gap-3 align-items-center">
      <app-tag-filter-dropdown
        (selectedTagsChange)="updateFilter()"
        [(selectedTags)]="filterQuery.tags"></app-tag-filter-dropdown>
    </div>
    <div class="flex gap-3 align-items-center">
      <app-product-filter-dropdown
        (selectedProductsChange)="updateFilter()"
        [(selectedProducts)]="
          filterQuery.products
        "></app-product-filter-dropdown>
    </div>
  </div>
</div>
